<script>
    import * as m from "@app/paraglide/messages.js";

    /** @type {{event: any}} */
    let { event } = $props();

    let positionInfo = $derived.by(() => {
        const yPos = event?.yPos;

        if (typeof yPos === "number") {
            const label = m.event_style_summary_position_other({ line: yPos });
            return { icon: "bi-distribute-vertical", label };
        }

        switch (yPos) {
            case "start":
            case "top":
                return { icon: "bi-align-top", label: m.input_position_y_top() };
            case "center":
            case "middle":
                return { icon: "bi-align-middle", label: m.input_position_y_center() };
            case "end":
            case "bottom":
            case undefined:
            case null:
            case "":
                return { icon: "bi-align-bottom", label: m.input_position_y_bottom() };
            default:
                return {
                    icon: "bi-distribute-vertical",
                    label: m.event_style_summary_position_other({ line: yPos }),
                };
        }
    });

    let styleInfo = $derived.by(() => {
        switch (event?.style) {
            case "Paint-On":
                return { icon: "bi-brush", label: m.input_caption_style_paint_on() };
            case "Roll-Up 2":
                return { icon: "bi-arrow-bar-up", label: m.input_caption_style_roll_up_2() };
            case "Roll-Up 3":
                return { icon: "bi-arrow-bar-up", label: m.input_caption_style_roll_up_3() };
            case "Roll-Up 4":
                return { icon: "bi-arrow-bar-up", label: m.input_caption_style_roll_up_4() };
            case "Pop-On":
            default:
                return { icon: "bi-chat-square-text", label: m.input_caption_style_pop_on() };
        }
    });
</script>

<div class="d-flex flex-column align-items-center gap-2 text-secondary">
    <i
        class="bi {styleInfo.icon} fs-5"
        role="img"
        title={styleInfo.label}
        aria-label={m.event_style_summary_style_aria({ label: styleInfo.label })}
    ></i>
    <i
        class="bi {positionInfo.icon} fs-5"
        role="img"
        title={positionInfo.label}
        aria-label={m.event_style_summary_position_aria({ label: positionInfo.label })}
    ></i>
</div>
